import { Injectable } from '@angular/core';
import { PaymentStatus, Status } from '../../../../shared/service-proxies/service-proxies';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

    constructor() { }
    status = Status;
    paymentStatus = PaymentStatus;

    getStatusBadgeClass(status: number): string {
        switch (status) {
            case this.status.Draft:
                return 'badge-secondary';
            case this.status.Partial:
                return 'badge-warning';
            case this.status.Delivered:
                return 'badge-info';
            case this.status.Transferred:
                return 'badge-info';
            case this.status.Approved:
                return 'badge-primary';
            case this.status.Received:
                return 'badge-success';
            case this.status.Invoiced:
                return 'badge-success';
            case this.status.Completed:
                return 'badge-success';
            case this.status.Adjusted:
                return 'badge-success';
            case this.status.Added:
                return 'badge-success';
            case this.status.Refunded:
                return 'badge-success';
            case this.status.Released:
                return 'badge-light';
            case this.status.Refunded:
                return 'badge-danger';
            case this.status.Processed:
                return 'badge-success';
            default:
                return 'badge-secondary';
        }
    }

    getPaymentStatusBadgeClass(paymentStatus: number): string {
        switch (paymentStatus) {
            case this.paymentStatus.UnPaid:
                return 'badge-danger';
            case this.paymentStatus.Paid:
                return 'badge-primary';
            case this.paymentStatus.Partial:
                return 'badge-info';
 
            default:
                return 'badge-secondary';
        }
    }
}
